import { render, staticRenderFns } from "./shopProductCard.vue?vue&type=template&id=6054ffac&scoped=true&"
import script from "./shopProductCard.vue?vue&type=script&lang=js&"
export * from "./shopProductCard.vue?vue&type=script&lang=js&"
import style0 from "./shopProductCard.vue?vue&type=style&index=0&id=6054ffac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6054ffac",
  null
  
)

export default component.exports